"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationBar = void 0;
/**
 * Behaviour-only wrapper around the navigation bar.
 *
 * The markup itself (brand, section links, their translated labels) is injected
 * at build time from src/components/templates/navigation-bar.html — see the
 * comment at the top of that file. Building it here in JavaScript meant the
 * links were invisible to crawlers and impossible to translate statically, so
 * all this class does now is toggle the scroll shadow.
 */
class NavigationBar {
    element;
    constructor() {
        this.element = document.querySelector('.navigation-bar');
    }
    updateShadow(hasScroll) {
        const navElement = this.element?.querySelector('nav');
        if (navElement) {
            navElement.classList.toggle('shadow-md', hasScroll);
            navElement.classList.toggle('dark:shadow-[0_4px_6px_-1px_rgba(255,255,255,0.1)]', hasScroll);
            navElement.classList.toggle('shadow-none', !hasScroll);
        }
    }
}
exports.NavigationBar = NavigationBar;
